import React, { useState } from 'react';

const ACTIONS = [
  'Mistake',
  'Cancelled',
  'Wrong Vehicle Entry'
];

const SupervisorActionModal = ({ isOpen, onClose, onSubmit, entryType, entryId }) => {
  const [action, setAction] = useState('');
  const [remarks, setRemarks] = useState('');

  if (!isOpen) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!action) return;
    onSubmit({ entry_type: entryType, entry_id: entryId, action, remarks });
  };

  return (
    <div className="modal-overlay">
      <div className="modal" style={{ minWidth: 340 }}>
        <h3>Mark Entry as...</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Action</label>
            <select value={action} onChange={e => setAction(e.target.value)} required>
              <option value="">Select Action</option>
              {ACTIONS.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
          </div>
          <div className="form-group">
            <label>Remarks</label>
            <textarea value={remarks} onChange={e => setRemarks(e.target.value)} />
          </div>
          <div className="modal-footer">
            <button type="submit" className="submit-button" disabled={!action}>Submit</button>
            <button type="button" className="cancel-button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupervisorActionModal;
